<template>
  <div>
    <errors :error-list="serverErrors"></errors>

    <h4 class="card-title mb-3">My Tasks</h4>

    <div class="card" v-if="isLoading">
      <div class="card-body">

        <div class="text-center">
          <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
        </div>

        <!--        <div v-if="!isLoading && tasks" class="table-responsive mb-0">-->
        <!--          <table class="table mb-0 table-centered">-->
        <!--            <thead class="thead-light">-->
        <!--            <tr>-->
        <!--              <th style="width: 50px;"></th>-->
        <!--              <th>Task</th>-->
        <!--              <th>Ticket</th>-->
        <!--              <th>Deadline</th>-->
        <!--            </tr>-->
        <!--            </thead>-->
        <!--            <tbody>-->
        <!--            <tr v-for="task in tasksWithDeadline" :class="{'bg-danger text-white': isTaskOverdue(task)}">-->
        <!--              <td>-->
        <!--                <input @change="() => toggleTask(task)" :checked="task.completed_at" type="checkbox"-->
        <!--                       :disabled="isToggling">-->
        <!--              </td>-->
        <!--              <td>-->
        <!--                <strike v-if="task.completed_at">{{ task.description }}</strike>-->
        <!--                <span v-else>{{ task.description }}</span>-->
        <!--              </td>-->
        <!--              <td><a :class="{'text-white': isTaskOverdue(task)}"-->
        <!--                     href="#"-->
        <!--                     @click.prevent="goToTicket(task.ticket)"-->
        <!--              >{{ task.ticket.subject }}</a></td>-->
        <!--              <td v-if="task.deadline">-->
        <!--                {{ displayTimestamp(task.deadline) }}-->
        <!--              </td>-->
        <!--              <td v-else>-->
        <!--                - -->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <tr v-for="task in tasksWithoutDeadline" :class="{'bg-danger text-white': isTaskOverdue(task)}">-->
        <!--              <td>-->
        <!--                <input @change="() => toggleTask(task)" :checked="task.completed_at" type="checkbox"-->
        <!--                       :disabled="isToggling">-->
        <!--              </td>-->
        <!--              <td>-->
        <!--                <strike v-if="task.completed_at">{{ task.description }}</strike>-->
        <!--                <span v-else>{{ task.description }}</span>-->
        <!--              </td>-->
        <!--              <td><a :class="{'text-white': isTaskOverdue(task)}"-->
        <!--                     @click.prevent="goToTicket(task.ticket)"-->
        <!--                     href="#">{{ task.ticket.subject }}</a></td>-->
        <!--              <td v-if="task.deadline">-->
        <!--                {{ displayTimestamp(task.deadline) }}-->
        <!--              </td>-->
        <!--              <td v-else>-->
        <!--                - -->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <tr v-if="tasks && tasks.length === 0">-->
        <!--              <th scope="row" colspan="4">-->
        <!--                <span class="text-danger">No results</span>-->
        <!--              </th>-->
        <!--            </tr>-->
        <!--            </tbody>-->
        <!--          </table>-->
        <!--        </div>-->

      </div>
    </div>

    <!-- Cards -->
    <div v-if="!isLoading" class="card-results-wrapper">
      <task-card v-for="task in tasksWithDeadline" :key="task.id" :task="task"></task-card>
      <task-card v-for="task in tasksWithoutDeadline" :key="task.id" :task="task"></task-card>

      <!-- No results -->
      <div class="card" v-if="tasks.length === 0">
        <div class="card-body">
          <b class="text-danger">No tasks</b>
        </div>
      </div>
      <!-- / No results -->
    </div>
    <!-- / Cards -->
  </div>
</template>

<script>
import Forms from "../../../../mixins/Forms";
import Dates from "../../../../mixins/Dates";
import Tasks from "../../../../mixins/Tasks";
import TaskCard from "./MyTasks/TaskCard";

let _ = require('lodash');
import axios from 'axios';

export default {
  name: "MyTasks",
  mixins: [Forms, Dates, Tasks],
  components: {TaskCard},
  data() {
    return {
      serverErrors: [],
      isLoading: false,
      tasks: null,
      isToggling: false
    }
  },

  computed: {
    tasksWithDeadline() {
      return _.filter(this.tasks, function (task) {
        return task.deadline !== null;
      });
    },

    tasksWithoutDeadline() {
      return _.filter(this.tasks, function (task) {
        return task.deadline === null;
      });
    }
  },

  methods: {
    loadTasks() {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoading = true;
      axios.get(API_BASE + '/tasks').then(r => {
        vm.tasks = r.data;
        vm.isLoading = false;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    },

    setup() {
      this.loadTasks();
    },

    getTicketUrl(ticket) {
      return '/tickets/' + ticket.id;
    },

    goToTicket(ticket) {
      this.$router.push(this.getTicketUrl(ticket));
    },

    toggleTask(task) {
      let vm = this;
      vm.isToggling = true;
      axios.post(API_BASE + '/tickets/' + task.ticket_id + '/tasks/' + task.id + '/toggle-completed').then(r => {
        vm.isToggling = false;
        if (task.completed_at) {
          task.completed_at = null;
        } else {
          task.completed_at = moment();
        }
      }).catch(e => {
        vm.isToggling = false;
        vm.notifyErrors(e);
      });
    }
  },

  watch: {
    '$route': 'setup'
  },

  created() {
    this.setup();
  }
}
</script>

<style scoped>

</style>
